/**
 * PrintSettingsUtils.js
 * Utilities for managing print settings and URL generation
 */

/**
 * Get current print settings from localStorage
 * @returns {Object} Current print settings
 */
export const getCurrentPrintSettings = () => {
  return {
    chords: localStorage.getItem('includeChordProgressions') !== 'false',
    colors: localStorage.getItem('includeSectionColors') !== 'false',
    collapse: localStorage.getItem('collapseSectionsInPdf') === 'true',
    pagebreak: localStorage.getItem('pageBreakBeforeChords') !== 'false'
  };
};

/**
 * Generate a print URL with current settings
 * @param {string} sheetId - Sheet ID to generate URL for
 * @param {Object} settings - Optional settings override (defaults to current localStorage settings)
 * @returns {string} Complete print URL with all parameters
 */
export const generatePrintUrl = (sheetId, settings = null) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/sheet/${sheetId}?perform=true`;
};

/**
 * Open a sheet in print view with current settings
 * @param {string} sheetId - Sheet ID to open
 * @param {string} target - Window target (default: '_blank')
 * @param {Object} settings - Optional settings override
 */
export const openSheetInPrintView = (sheetId, target = '_blank', settings = null) => {
  const printUrl = generatePrintUrl(sheetId, settings);
  window.open(printUrl, target);
};